import React from "react";
import { IoClose } from "react-icons/io5";

const BasicModal = ({
  open,
  handleOpenModal,
  handleCloseModal,
  children,
  trigger,
  title,
}) => {
  return (
    <>
      {open && (
        <>
          <div className="modal-overlay" onClick={handleCloseModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="flex items-center justify-between w-full">
                <p className="font-semibold">{title}</p>
                <div className="bg-red-300 text-white p-2 rounded-md hover:bg-red-700" onClick={handleCloseModal}><IoClose/></div>
              </div>
              {children}
            </div>
          </div>
        </>
      )}
      {trigger}
    </>
  );
};

export default BasicModal;
